import { surveyLocalization } from "survey-core";

export var georgianSurveyStrings = {
  pagePrevText: "უკან",
  pageNextText: "შემდეგ",
  completeText: "დასრულება",
  progressText: "გვერდი {0} / {1}",
  emptySurvey: "არცერთი კითხვა არ არის.",
  completingSurvey: "გმადლობთ კითხვარის შევსებისთვის!",
  loadingSurvey: "ჩატვირთვა სერვერიდან...",
  otherItemText: "სხვა (გთხოვთ მიუთითეთ)",
  optionsCaption: "არჩევა...",
  requiredError: "გთხოვთ უპასუხეთ კითხვას.",
  numericError: "პასუხი უნდა იყოს რიცხვი.",
  textMinLength: "გთხოვთ შეიყვანეთ არანაკლებ {0} სიმბოლო.",
  minSelectError: "გთხოვთ აირჩიეთ არანაკლებ {0} ვარიანტი.",
  maxSelectError: "გთხოვთ აირჩიეთ არაუმეტეს {0} ვარიანტი.",
  numericMinMax:
    "'{0}' უნდა იყოს მეტი ან ტოლი, ვიდრე {1}, და ნაკლები ან ტოლი ვიდრე {2}",
  numericMin: "'{0}' უნდა იყოს მეტი ან ტოლი ვიდრე {1}",
  numericMax: "'{0}' უნდა იყოს ნაკლები ან ტოლი ვიდრე {1}",
  invalidEmail: "გთხოვთ შეიყვანოთ ელ. ფოსტის რეალური მისამართი.",
  otherRequiredEror: "გთხოვთ შეავსეთ ველი 'სხვა'"
};

surveyLocalization.locales["ka"] = georgianSurveyStrings;
surveyLocalization.localeNames["ka"] = "ქართული";
